import config from '../config/config';
import { SourcesIds } from '../constants/SOURCES';

export const announcementsSources = {
  async loadAnnouncements() {
    const { settings, metaController } = window.Widget;
    const currency_code = settings.currency || 'RUB';
    const eventDateId =
      metaController.selectedEvent || settings.selectedEvent || settings.eventDateId;
    const params = new URLSearchParams({
      event_date_id: eventDateId,
      event_source_id: settings.eventSourceId,
      currency_code,
      source_id: settings.isLanding ? SourcesIds.landings : SourcesIds.marketplace,
    });

    const data = await fetch(`${config.aggregatedApiRoute}/public/v2/announcements?${params}`).then(
      (r) => {
        if (r.ok) {
          return r.json();
        }

        throw new Error('Something went wrong');
      },
    );

    return data;
  },
};
